import { render, staticRenderFns } from "./BRegister.vue?vue&type=template&id=245fce2e"
import script from "./BRegister.vue?vue&type=script&setup=true&lang=ts"
export * from "./BRegister.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports